type RenewableBooking = { status?: string; type?: string; departure_date?: string; rentCycle?: string } | null | undefined;

const RENEWAL_WINDOW_DAYS = { yearly: 90, monthly: 14 };

export function renewalOpensAt(booking: RenewableBooking): Date | null {
  const endsAt = Date.parse(booking?.departure_date || "");
  if (!Number.isFinite(endsAt)) return null;
  const days = RENEWAL_WINDOW_DAYS[booking?.rentCycle === "monthly" ? "monthly" : "yearly"];
  return new Date(endsAt - days * 24 * 60 * 60 * 1000);
}

export function canRenewRent(booking: RenewableBooking): boolean {
  if (!booking || booking.status !== "confirmed" || booking.type === "renewal") return false;
  const opensAt = renewalOpensAt(booking);
  return !!opensAt && opensAt.getTime() <= Date.now();
}

export function renewalUnavailableMessage(booking: RenewableBooking): string {
  const opensAt = booking?.status === "confirmed" && booking.type !== "renewal" ? renewalOpensAt(booking) : null;
  if (opensAt && opensAt.getTime() > Date.now()) {
    return `Renewal opens on ${opensAt.toLocaleDateString("en-NG", { day: "numeric", month: "long", year: "numeric" })}`;
  }
  return "Renewal is available while your tenancy is active";
}
